import { RevenueBreakdownSchema } from '@vy/types';
import { oz } from '@vy/utils';
import { ProductErpFormInputSchema } from '../../../../CustomerInvoicePage/customer-invoice-page-components/InvoiceActivity/invoice-activity-components/InvoiceActivityTabs/invoice-activity-tabs/InvoiceActivityErpSyncTab/Invoice-activity-erp-sync-tab-components/ErpProductSettingsAccordion/erp-product-settings-accordion-types/product-erp-form-input-schema';
import { ProductClassFormInputSchema } from '../../../../CustomerInvoicePage/customer-invoice-page-components/InvoiceActivity/invoice-activity-components/InvoiceActivityTabs/invoice-activity-tabs/InvoiceActivityErpSyncTab/Invoice-activity-erp-sync-tab-components/ErpProductSettingsAccordion/erp-product-settings-accordion-types/product-class-form-input-schema';

export const FixedRevisionedLineItemFormSchema = oz.object({
  modifiedName: oz.string().nonempty(),
  modifiedDescription: oz.string().optional(),
  revenueBreakdown: RevenueBreakdownSchema,
  netSuiteProduct: ProductErpFormInputSchema.array().default([]),
  classMetadata: ProductClassFormInputSchema.nullish().default(null),
  xeroProductId: oz.string().nullish().default(null),
});

export type FixedRevisionedLineItemForm = oz.infer<typeof FixedRevisionedLineItemFormSchema>;
